export default __webpack_public_path__ + "static/media/Piratenlogoblack.717885aa.png";